export default {
    'create-custom-statement': 'Crear estado personalizado',
    'edit-custom-statement': 'Editar estado personalizado',
    'custom-statement-name': 'Nombre de estado personalizado',
    'accounts': 'Cuentas',
    save: 'Guardar',
    cancel: 'Cancelar',
    'delete-the-custom-statement': 'Eliminar estado personalizado',
    'are-you-sure-you-want-to-delete-the-custom-statement': '¿Estas seguro de eliminar el estado personalizado?',

    headers: {
        'custom-statement-name': 'Nombre de estado personalizado',
        'used-accounts': 'Cuentas relacionadas',
        'actions': 'Acciones',
    }
}